export const getCompanyDetails = (companyId: number) => `/api/companies/${companyId}`;

export default {
  getCompanyDetails,
};
